export default {
  editor_button_text_placeholderRequestNumber: 'Request Number',
  contactCard_default_status:
    'Not on flock yet - but you can message to reach out',
};
